import {
    BrandLogoComponent, TitleComponent, SubtitleComponent
} from '../../uicomponents'
import { SocialComponent } from '../Social/Social'
import FormPlacesWaitlistComponent from '../FormPlacesWaitlist/FormPlacesWaitlist'
import { ClientTypes } from '../../utilities/constants'
import styles from './PlacesWaitlist.module.scss'

const PlacestWaitlistComponent = () => {
    return (
        <div className={styles.contentForm}>
            <BrandLogoComponent
                client={ClientTypes.PLACES}
            />
            <SubtitleComponent>
                Sé el primero en enterarte.
            </SubtitleComponent>
            <TitleComponent>
                Sumate a nuestra waitlist. <br/> Estamos cocinando algo para vos.
            </TitleComponent>
            <FormPlacesWaitlistComponent />
            <SocialComponent />
        </div>
    )
}

export default PlacestWaitlistComponent
